var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_81_1",
    "data-name": "Component 81 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.98,
    height: 36,
    viewBox: "0 0 35.98 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.096,
    y1: 0.18,
    x2: 1,
    y2: 1.209,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34bc83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adf4d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744",
    opacity: 0.498
  }, /*#__PURE__*/React.createElement("path", {
    id: "recycling_FILL0_wght600_GRAD0_opsz48",
    d: "M15.36,15.618l3.774-6.263L16.646,5.166a1.708,1.708,0,0,0-1.514-.829,1.612,1.612,0,0,0-1.472.829L9.471,12.134Zm16.548,11.7-3.816-6.387,5.972-3.4,2.737,4.6a3.231,3.231,0,0,1,.477,1.638,3.428,3.428,0,0,1-.353,1.638,3.348,3.348,0,0,1-1.286,1.41,3.407,3.407,0,0,1-1.783.5ZM26.973,39.3,20.13,32.415l6.843-6.843v3.442H35.1l-2.447,4.977a3.768,3.768,0,0,1-1.306,1.369,3.374,3.374,0,0,1-1.8.5H26.973ZM10.424,35.858a2.939,2.939,0,0,1-1.576-.435A2.606,2.606,0,0,1,7.812,34.24a2.89,2.89,0,0,1-.353-1.452,2.766,2.766,0,0,1,.435-1.41l1.452-2.364h7.383v6.843ZM6.153,30.964,3.415,25.406A2.782,2.782,0,0,1,3,23.788a3.367,3.367,0,0,1,.539-1.659l.664-1.2L1.3,19.185l9.373-2.323L13,26.277l-2.9-1.825ZM29.3,16.323l-9.373-2.364,2.945-1.742L17.517,3.3h6.055a3.155,3.155,0,0,1,1.659.477A4.032,4.032,0,0,1,26.517,5l2.2,3.691L31.66,6.908Z",
    transform: "translate(-1.3 -3.3)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.657f398cb606495666b9ed203365590f.svg";
export { ForwardRef as ReactComponent };